import React from 'react';
import PageToggleBanner from './PageToggleBanner';

const creditCategories = ['Theatre', 'Film', 'Television', 'Voice', 'Commercial', 'Other'];
const skillCategories = [
  'Dialects',
  'Dance',
  'Instruments',
  'Combat',
  'Sports',
  'Languages',
  'General',
];

function ResumeTab({
  hiddenSections,
  handleToggleSection,
  // Resume scanner
  resumeScanning,
  scannedCredits,
  resumeType,
  setResumeType,
  handleResumeScan,
  handleEditScannedCredit,
  handleRemoveScannedCredit,
  handleConfirmScannedCredits,
  // Credits
  credits,
  newCredit,
  setNewCredit,
  handleAddCredit,
  handleDeleteCredit,
  handleToggleFeatured,
  // Skills
  skills,
  newSkill,
  setNewSkill,
  handleAddSkill,
  handleDeleteSkill,
  // Resume PDF
  resumePdfName,
  handleUploadResume,
  handleRemoveResume,
  // Save
  handleSaveAll,
  saving,
}) {
  return (
    <>
      {/* REVIEW: extracted to PageToggleBanner */}
      <PageToggleBanner
        label="Resume Page"
        enabled={!hiddenSections.includes('resume')}
        onToggle={() => handleToggleSection('resume')}
      />

      <div className="resume-networking-banner">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
        <div>
          <strong>Help us connect you</strong>
          <p>
            Filling out your resume here helps us better connect you with people on the app. We'll
            use your connections to find close connections to you.
          </p>
        </div>
      </div>

      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Credits</h2>
          <p>Your productions and roles</p>
        </div>

        {/* Resume Scanner */}
        <div className="resume-scan-section">
          <div className="resume-scan-row">
            <label className={`btn-scan-resume${resumeScanning ? ' scanning' : ''}`}>
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
              </svg>
              {resumeScanning ? 'Scanning...' : 'Scan Resume'}
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png,.webp"
                style={{ display: 'none' }}
                onChange={(e) => {
                  if (e.target.files[0]) handleResumeScan(e.target.files[0]);
                  e.target.value = '';
                }}
                disabled={resumeScanning}
              />
            </label>
            <select
              className="resume-type-inline-select"
              value={resumeType}
              onChange={(e) => setResumeType(e.target.value)}
            >
              <option value="performer">Performer</option>
              <option value="director">Director</option>
              <option value="stage_manager">Stage Manager</option>
              <option value="choreographer">Choreographer</option>
              <option value="designer">Designer</option>
              <option value="general">Other</option>
            </select>
          </div>
          <span className="resume-scan-hint">
            Upload a PDF or photo of your resume to auto-fill credits and skills
          </span>
        </div>

        {resumeScanning && (
          <div className="resume-scan-loading">
            <div className="resume-scan-spinner" />
            <span>Scanning your resume with AI... This may take a moment.</span>
          </div>
        )}

        {scannedCredits && scannedCredits.length > 0 && (
          <div className="scanned-credits-review">
            <div className="scanned-credits-header">
              <h4>Review Scanned Credits ({scannedCredits.length})</h4>
              <p>Edit any fields before adding. Remove any incorrect entries.</p>
            </div>
            <div className="scanned-credits-table-wrap">
              <table className="scanned-credits-table">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Production</th>
                    <th>Role</th>
                    <th>Company</th>
                    <th>Director</th>
                    <th>Year</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {scannedCredits.map((credit, idx) => (
                    <tr key={idx}>
                      <td>
                        <select
                          value={credit.category || 'Theatre'}
                          onChange={(e) => handleEditScannedCredit(idx, 'category', e.target.value)}
                        >
                          {creditCategories.map((cat) => (
                            <option key={cat} value={cat}>
                              {cat}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          type="text"
                          value={credit.production || ''}
                          onChange={(e) =>
                            handleEditScannedCredit(idx, 'production', e.target.value)
                          }
                          placeholder="Production"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={credit.role || ''}
                          onChange={(e) => handleEditScannedCredit(idx, 'role', e.target.value)}
                          placeholder="Role"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={credit.company || ''}
                          onChange={(e) => handleEditScannedCredit(idx, 'company', e.target.value)}
                          placeholder="Company"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={credit.director || ''}
                          onChange={(e) => handleEditScannedCredit(idx, 'director', e.target.value)}
                          placeholder="Director"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={credit.year || ''}
                          onChange={(e) => handleEditScannedCredit(idx, 'year', e.target.value)}
                          placeholder="Year"
                          style={{ width: '60px' }}
                        />
                      </td>
                      <td>
                        <button
                          className="btn-remove-small"
                          onClick={() => handleRemoveScannedCredit(idx)}
                        >
                          ×
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="scanned-credits-actions">
              <button className="btn-add" onClick={handleConfirmScannedCredits} disabled={saving}>
                {saving ? 'Adding...' : `Confirm & Add All (${scannedCredits.length})`}
              </button>
              <button className="btn-cancel" onClick={() => handleRemoveScannedCredit('all')}>
                Cancel
              </button>
            </div>
          </div>
        )}

        {credits.length > 0 && (
          <div className="credits-list">
            {creditCategories.map((cat) => {
              const catCredits = credits.filter((c) => c.category === cat);
              if (catCredits.length === 0) return null;
              return (
                <div key={cat} className="credit-category">
                  <h3>{cat}</h3>
                  {catCredits.map((credit) => (
                    <div
                      key={credit.id}
                      className={`credit-item ${credit.is_featured ? 'credit-featured' : ''}`}
                    >
                      <div className="credit-info">
                        <strong>{credit.role}</strong> - {credit.production}
                        {credit.company && <span> ({credit.company})</span>}
                        {credit.director && <span> &bull; Dir: {credit.director}</span>}
                        {credit.year && <span> &bull; {credit.year}</span>}
                      </div>
                      <div className="credit-actions">
                        <button
                          className={`btn-feature-credit ${credit.is_featured ? 'featured' : ''}`}
                          onClick={() => handleToggleFeatured(credit.id)}
                          title={
                            credit.is_featured
                              ? 'Remove from featured'
                              : 'Feature this credit (shown on your card)'
                          }
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill={credit.is_featured ? 'currentColor' : 'none'}
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                          </svg>
                        </button>
                        <button
                          className="btn-remove-small"
                          onClick={() => handleDeleteCredit(credit.id)}
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        )}
        <div className="add-item-form">
          <h4>Add Credit</h4>
          <div className="form-row">
            <div className="form-group">
              <label>Category</label>
              <select
                value={newCredit.category}
                onChange={(e) => setNewCredit({ ...newCredit, category: e.target.value })}
              >
                {creditCategories.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Year</label>
              <input
                type="text"
                value={newCredit.year}
                onChange={(e) => setNewCredit({ ...newCredit, year: e.target.value })}
                placeholder="2024"
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Role *</label>
              <input
                type="text"
                value={newCredit.role}
                onChange={(e) => setNewCredit({ ...newCredit, role: e.target.value })}
                placeholder="Character name"
              />
            </div>
            <div className="form-group">
              <label>Production *</label>
              <input
                type="text"
                value={newCredit.production}
                onChange={(e) => setNewCredit({ ...newCredit, production: e.target.value })}
                placeholder="Show/Film title"
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Company/Theater</label>
              <input
                type="text"
                value={newCredit.company}
                onChange={(e) => setNewCredit({ ...newCredit, company: e.target.value })}
                placeholder="Steppenwolf Theatre"
              />
            </div>
            <div className="form-group">
              <label>Director</label>
              <input
                type="text"
                value={newCredit.director}
                onChange={(e) => setNewCredit({ ...newCredit, director: e.target.value })}
                placeholder="Director name"
              />
            </div>
          </div>
          <button className="btn-add" onClick={handleAddCredit}>
            + Add Credit
          </button>
        </div>
      </div>

      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Special Skills</h2>
          <p>Dialects, instruments, combat, and more</p>
        </div>
        {skills.length > 0 && (
          <div className="skills-list">
            {skillCategories.map((cat) => {
              const catSkills = skills.filter((s) => s.category === cat);
              if (catSkills.length === 0) return null;
              return (
                <div key={cat} className="skill-category">
                  <h3>{cat}</h3>
                  <div className="skill-tags">
                    {catSkills.map((skill) => (
                      <span key={skill.id} className="skill-tag">
                        {skill.skill}
                        {skill.proficiency && <small> ({skill.proficiency})</small>}
                        <button
                          className="btn-remove-tag"
                          onClick={() => handleDeleteSkill(skill.id)}
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <div className="add-item-form">
          <h4>Add Skill</h4>
          <div className="form-row form-row-3">
            <div className="form-group">
              <label>Category</label>
              <select
                value={newSkill.category}
                onChange={(e) => setNewSkill({ ...newSkill, category: e.target.value })}
              >
                {skillCategories.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Skill *</label>
              <input
                type="text"
                value={newSkill.skill}
                onChange={(e) => setNewSkill({ ...newSkill, skill: e.target.value })}
                placeholder="British RP, Tap, Guitar..."
              />
            </div>
            <div className="form-group">
              <label>Proficiency</label>
              <input
                type="text"
                value={newSkill.proficiency}
                onChange={(e) => setNewSkill({ ...newSkill, proficiency: e.target.value })}
                placeholder="Advanced, Beginner..."
              />
            </div>
          </div>
          <button className="btn-add" onClick={handleAddSkill}>
            + Add Skill
          </button>
        </div>
      </div>

      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Downloadable Resume</h2>
          <p>Upload a PDF of your resume for visitors to download</p>
        </div>
        {resumePdfName ? (
          <div className="resume-pdf-current">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
            <span>{resumePdfName}</span>
            <button className="btn-remove-small" onClick={handleRemoveResume}>
              Remove
            </button>
          </div>
        ) : (
          <label className="resume-pdf-upload">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
            <span>Click to upload resume PDF</span>
            <small>PDF files only</small>
            <input
              type="file"
              accept=".pdf"
              onChange={handleUploadResume}
              style={{ display: 'none' }}
            />
          </label>
        )}
      </div>

      <button className="btn-save-section" onClick={handleSaveAll} disabled={saving}>
        {saving ? 'Saving...' : 'Save Resume'}
      </button>
    </>
  );
}

export default ResumeTab;
